// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1MyoX","vLegacy":"SelectSecondary_vLegacy__7T2lP","error":"SelectSecondary_error__36DcL","disabled":"SelectSecondary_disabled__16AZu"};